// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordRequirements-m__0oHAwfsF0Cczdjs2FY7 {
    color: var(--success);
}

.PasswordRequirements-m_LcpA66tR7lCKkuOZs_BZ {
    color: var(--error);
}
`, "",{"version":3,"sources":["webpack://./client/login/PasswordRequirements/PasswordRequirements.m.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".validPass {\n    color: var(--success);\n}\n\n.invalidPass {\n    color: var(--error);\n}\n"],"sourceRoot":""}]);
// Exports
export var validPass = `PasswordRequirements-m__0oHAwfsF0Cczdjs2FY7`;
export var invalidPass = `PasswordRequirements-m_LcpA66tR7lCKkuOZs_BZ`;
export default ___CSS_LOADER_EXPORT___;
